// Generated by ReScript, PLEASE EDIT WITH CARE

import * as SWR from "../../../../node_modules/rescript-swr/lib/es6_global/src/SWR.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Belt_SortArray from "../../../../node_modules/rescript/lib/es6/belt_SortArray.js";
import * as Store$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/Store/Store.bs.js";
import * as Caml_exceptions from "../../../../node_modules/rescript/lib/es6/caml_exceptions.js";
import * as Facets$Showside from "../types/Facets.bs.js";
import * as Markets$Showside from "../types/Markets.bs.js";
import * as Shopify$Showside from "../utils/Shopify.bs.js";
import * as Js_null_undefined from "../../../../node_modules/rescript/lib/es6/js_null_undefined.js";
import * as URLUtils$Showside from "../utils/URLUtils.bs.js";
import * as DeccoUtils$Showside from "../utils/DeccoUtils.bs.js";
import * as FetchUtils$Showside from "../utils/FetchUtils.bs.js";
import * as SWRScrapeCache$Showside from "../utils/SWRScrapeCache.bs.js";
import * as MarketsDecoders$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/MarketsDecoders.bs.js";
import * as RescriptJsonUtils$Showside from "../utils/RescriptJsonUtils.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as CustomerAnimusMedicusDe$Showside from "../customers/CustomerAnimusMedicusDe.bs.js";
import * as SWRProductGroupByProductId$Showside from "../utils/SWRProductGroupByProductId.bs.js";
import * as IntermediateProductsResponse$Showside from "../types/IntermediateProductsResponse.bs.js";
import * as Store_ProductSortOrderCodecs$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/Store/Store_ProductSortOrderCodecs.bs.js";
import * as LegacyShowside_CategoryDecoders$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/LegacyShowside/LegacyShowside_CategoryDecoders.bs.js";
var NotFound = /* @__PURE__ */Caml_exceptions.create("UseApi-Showside.NotFound");
function toInfiniteProductsResponse(swrInfiniteResult) {
  var error = swrInfiniteResult.error;
  var data = swrInfiniteResult.data;
  var reachedEnd = Belt_Option.getWithDefault(Belt_Option.map(Belt_Option.flatMap(data, function (pages) {
    return Belt_Array.get(pages, pages.length - 1 | 0);
  }), function (lastPage) {
    return lastPage.page.next === undefined;
  }), false);
  var numLoadedPages = Belt_Option.getWithDefault(Belt_Option.map(data, function (prim) {
    return prim.length;
  }), 0);
  var firstPage = Belt_Option.flatMap(data, function (__x) {
    return Belt_Array.get(__x, 0);
  });
  var products = Belt_Option.map(data, function (data) {
    return Belt_Array.concatMany(Belt_Array.map(data, function (page) {
      return page.products;
    }));
  });
  var filters = Belt_Option.flatMap(firstPage, function (page) {
    return page.filters;
  });
  var defaultSortOrder = Belt_Option.flatMap(firstPage, function (page) {
    return page.defaultSortOrder;
  });
  var availableSorts = Belt_Option.flatMap(firstPage, function (page) {
    return page.availableSorts;
  });
  var total = Belt_Option.flatMap(firstPage, function (page) {
    return page.total;
  });
  var syncStatus = Belt_Option.flatMap(firstPage, function (page) {
    return page.syncStatus;
  });
  return {
    products: products,
    filters: filters,
    availableSorts: availableSorts,
    defaultSortOrder: defaultSortOrder,
    numPages: swrInfiniteResult.size,
    setNumPages: swrInfiniteResult.setSize,
    numLoadedPages: numLoadedPages,
    reachedEnd: reachedEnd,
    error: error,
    isFetching: data === undefined && error === undefined,
    total: total,
    syncStatus: syncStatus
  };
}
var isGood = d => {
  if (d.hasOwnProperty("data")) {
    return d.data !== 1;
  } else {
    return true;
  }
};
function fixSWRInfiniteResult(response) {
  var data = Belt_Option.map(response.data, function (data) {
    return Belt_Array.keep(data, isGood);
  });
  var error = Belt_Option.keep(response.error, isGood);
  return {
    data: data,
    size: response.size,
    setSize: response.setSize,
    isValidating: response.isValidating,
    error: error,
    mutate: response.mutate
  };
}
function fixSWRResult(response) {
  var data = Belt_Option.keep(response.data, isGood);
  var error = Belt_Option.keep(response.error, isGood);
  return {
    error: error,
    data: data,
    isValidating: response.isValidating,
    mutate: response.mutate
  };
}
function useSWRInfinite(getKey, fetcher) {
  return fixSWRInfiniteResult(SWR.useSWRInfinite(undefined, undefined, undefined, undefined, false, undefined, false, getKey, fetcher));
}
function useSWR(key, fetcher) {
  return fixSWRResult(SWR.useSWR(undefined, undefined, undefined, false, key, fetcher));
}
function useCategoryProducts2(storeId, categoryId, connection, hideOutOfStock, appliedFilters, defaultFilters, limitOpt, sort, shouldFetch, smartnavApiHost, market, param) {
  var limit = limitOpt !== undefined ? limitOpt : 10;
  var match = Markets$Showside.getValues(market);
  var language = Belt_Option.map(Shopify$Showside.getLanguage(undefined), function (prim) {
    return prim.toUpperCase();
  });
  var match$1 = CustomerAnimusMedicusDe$Showside.useParseMarket(match.country, match.currency, language);
  var language$1 = match$1[2];
  var currency = match$1[1];
  var country = match$1[0];
  var appliedFilters$1 = Facets$Showside.mergeOption(appliedFilters, defaultFilters);
  var sort$1 = Belt_Option.map(Belt_Option.orElse(sort, Belt_Option.map(connection, function (connection) {
    return connection.sortBy;
  })), Store_ProductSortOrderCodecs$ApiTypes.ProductSortOrder.toString);
  var shouldFetch$1 = shouldFetch && connection !== undefined;
  var getKey = function (param, lastPage) {
    var page = Belt_Option.flatMap(lastPage == null ? undefined : Caml_option.some(lastPage), function (lastPage) {
      return lastPage.page.next;
    });
    var end = Belt_Option.getWithDefault(Belt_Option.map(lastPage == null ? undefined : Caml_option.some(lastPage), function (lastPage) {
      return lastPage.page.next === undefined;
    }), false);
    if (connection !== undefined && storeId !== undefined && !(end || !shouldFetch$1)) {
      return smartnavApiHost + "/api/get_products_by_category2?category_id=" + connection.categoryId + "&store_id=" + storeId + Belt_Option.mapWithDefault(page, "", function (page) {
        return "&page=" + page;
      }) + Belt_Option.mapWithDefault(sort$1, "", function (sort) {
        return "&sort=" + sort;
      }) + (hideOutOfStock ? "&in_stock=true" : "") + Belt_Option.mapWithDefault(appliedFilters$1, "", function (af) {
        return "&facets=" + Facets$Showside.toStringOfIndex(af);
      }) + Belt_Option.mapWithDefault(Belt_Option.flatMap(appliedFilters$1, function (param) {
        return param.minPrice;
      }), "", function (minPrice) {
        return "&min_price=" + String(minPrice | 0);
      }) + Belt_Option.mapWithDefault(Belt_Option.flatMap(appliedFilters$1, function (param) {
        return param.maxPrice;
      }), "", function (maxPrice) {
        return "&max_price=" + String(maxPrice | 0);
      }) + "&limit=" + String(limit) + Belt_Option.mapWithDefault(country, "", function (country) {
        return "&country=" + country;
      }) + Belt_Option.mapWithDefault(currency, "", function (currency) {
        return "&currency=" + currency;
      }) + Belt_Option.mapWithDefault(language$1, "", function (language) {
        return "&language=" + language;
      });
    } else {
      return null;
    }
  };
  var fetcher = function (key) {
    if (connection !== undefined && storeId !== undefined) {
      return FetchUtils$Showside.$$fetch(undefined, undefined, undefined, undefined, undefined, async function (json) {
        return IntermediateProductsResponse$Showside.Page.fromJson(appliedFilters$1, hideOutOfStock, categoryId, storeId, json);
      }, key);
    } else {
      return Promise.resolve(IntermediateProductsResponse$Showside.Page.empty);
    }
  };
  return toInfiniteProductsResponse(useSWRInfinite(getKey, fetcher));
}
function useCategoryProducts3(storeId, categoryId, connection, hideOutOfStock, appliedFilters, defaultFilters, limitOpt, sort, shouldFetch, smartnavApiHost, market, param) {
  var limit = limitOpt !== undefined ? limitOpt : 10;
  var match = Markets$Showside.getValues(market);
  var language = Belt_Option.map(Shopify$Showside.getLanguage(undefined), function (prim) {
    return prim.toUpperCase();
  });
  var match$1 = CustomerAnimusMedicusDe$Showside.useParseMarket(match.country, match.currency, language);
  var language$1 = match$1[2];
  var currency = match$1[1];
  var country = match$1[0];
  var appliedFilters$1 = Facets$Showside.mergeOption(appliedFilters, defaultFilters);
  var sort$1 = Belt_Option.map(Belt_Option.orElse(sort, Belt_Option.map(connection, function (connection) {
    return connection.sortBy;
  })), Store_ProductSortOrderCodecs$ApiTypes.ProductSortOrder.toString);
  var getKey = function (param, lastPage) {
    var next = Belt_Option.flatMap(lastPage == null ? undefined : Caml_option.some(lastPage), function (lastPage) {
      return lastPage.page.next;
    });
    var end = Belt_Option.getWithDefault(Belt_Option.map(lastPage == null ? undefined : Caml_option.some(lastPage), function (lastPage) {
      return lastPage.page.next === undefined;
    }), false);
    if (connection !== undefined && storeId !== undefined && shouldFetch && !end) {
      return Belt_Option.getWithDefault(next, smartnavApiHost + "/api/get_products_by_category3?category_id=" + connection.categoryId + "&store_id=" + storeId + Belt_Option.mapWithDefault(sort$1, "", function (sort) {
        return "&sort=" + sort;
      }) + (hideOutOfStock ? "&in_stock=true" : "") + Belt_Option.mapWithDefault(appliedFilters$1, "", function (af) {
        return "&facets=" + Facets$Showside.toStringOfIndex(af);
      }) + Belt_Option.mapWithDefault(Belt_Option.flatMap(appliedFilters$1, function (param) {
        return param.minPrice;
      }), "", function (minPrice) {
        return "&min_price=" + String(minPrice | 0);
      }) + Belt_Option.mapWithDefault(Belt_Option.flatMap(appliedFilters$1, function (param) {
        return param.maxPrice;
      }), "", function (maxPrice) {
        return "&max_price=" + String(maxPrice | 0);
      }) + "&limit=" + String(limit) + Belt_Option.mapWithDefault(country, "", function (country) {
        return "&country=" + country;
      }) + Belt_Option.mapWithDefault(currency, "", function (currency) {
        return "&currency=" + currency;
      }) + Belt_Option.mapWithDefault(language$1, "", function (language) {
        return "&language=" + language;
      }));
    } else {
      return null;
    }
  };
  var fetcher = function (key) {
    if (storeId !== undefined) {
      return FetchUtils$Showside.$$fetch(undefined, undefined, undefined, undefined, undefined, async function (json) {
        return IntermediateProductsResponse$Showside.Page.fromJson(appliedFilters$1, hideOutOfStock, categoryId, storeId, json);
      }, key);
    } else {
      return Promise.resolve(IntermediateProductsResponse$Showside.Page.empty);
    }
  };
  return toInfiniteProductsResponse(useSWRInfinite(getKey, fetcher));
}
function useCategoryProducts(storeId, categoryId, connection, hideOutOfStock, appliedFilters, defaultFilters, limitOpt, sort, shouldFetch, smartnavApiHost, market, param) {
  var limit = limitOpt !== undefined ? limitOpt : 10;
  var useV3 = Belt_Option.isSome(Caml_option.nullable_to_opt(new URL(window.location.href).searchParams.get("maker_use_get_products_by_category3")));
  if (useV3) {
    return useCategoryProducts3(storeId, categoryId, connection, hideOutOfStock, appliedFilters, defaultFilters, limit, sort, shouldFetch, smartnavApiHost, market, undefined);
  } else {
    return useCategoryProducts2(storeId, categoryId, connection, hideOutOfStock, appliedFilters, defaultFilters, limit, sort, shouldFetch, smartnavApiHost, market, undefined);
  }
}
function useRelatedProducts(productId, storeId, categoryId, hideOutOfStock, shouldFetch, smartnavApiHost, market, param) {
  var match = Markets$Showside.getValues(market);
  var language = Belt_Option.map(Shopify$Showside.getLanguage(undefined), function (prim) {
    return prim.toUpperCase();
  });
  var match$1 = CustomerAnimusMedicusDe$Showside.useParseMarket(match.country, match.currency, language);
  var language$1 = match$1[2];
  var currency = match$1[1];
  var country = match$1[0];
  var getKey = function (param, lastPage) {
    var page = Belt_Option.flatMap(lastPage == null ? undefined : Caml_option.some(lastPage), function (lastPage) {
      return lastPage.page.next;
    });
    var end = Belt_Option.getWithDefault(Belt_Option.map(lastPage == null ? undefined : Caml_option.some(lastPage), function (lastPage) {
      return lastPage.page.next === undefined;
    }), false);
    if (productId !== undefined && !(end || !shouldFetch)) {
      return smartnavApiHost + "/api/get_related_products?product_id=" + productId + Belt_Option.mapWithDefault(storeId, "", function (storeId) {
        return "&store_id=" + storeId;
      }) + Belt_Option.mapWithDefault(page, "", function (page) {
        return "&page=" + page;
      }) + "&limit=" + String(10) + (hideOutOfStock ? "&in_stock=true" : "") + Belt_Option.mapWithDefault(country, "", function (country) {
        return "&country=" + country;
      }) + Belt_Option.mapWithDefault(currency, "", function (currency) {
        return "&currency=" + currency;
      }) + Belt_Option.mapWithDefault(language$1, "", function (language) {
        return "&language=" + language;
      });
    } else {
      return null;
    }
  };
  var fetcher = function (key) {
    if (storeId !== undefined) {
      return FetchUtils$Showside.$$fetch(undefined, undefined, undefined, undefined, undefined, async function (json) {
        return IntermediateProductsResponse$Showside.Page.fromJson(undefined, hideOutOfStock, undefined, storeId, json);
      }, key);
    } else {
      return Promise.resolve(IntermediateProductsResponse$Showside.Page.empty);
    }
  };
  return toInfiniteProductsResponse(useSWRInfinite(getKey, fetcher));
}
function useProductsByIdAndPage(storeId, getIds, hideOutOfStock, shouldFetch, categoryId, smartnavApiHost, market, param) {
  var match = Markets$Showside.getValues(market);
  var language = Belt_Option.map(Shopify$Showside.getLanguage(undefined), function (prim) {
    return prim.toUpperCase();
  });
  var match$1 = CustomerAnimusMedicusDe$Showside.useParseMarket(match.country, match.currency, language);
  var language$1 = match$1[2];
  var currency = match$1[1];
  var country = match$1[0];
  var getKey = function (page, param) {
    var ids = Curry._1(getIds, page);
    var shouldFetch$1 = shouldFetch && ids.length !== 0;
    if (storeId !== undefined && shouldFetch$1) {
      return smartnavApiHost + "/api/get_products?product_ids=" + ids.join(",") + ("&store_id=" + storeId) + (hideOutOfStock ? "&in_stock=true" : "") + Belt_Option.mapWithDefault(country, "", function (country) {
        return "&country=" + country;
      }) + Belt_Option.mapWithDefault(currency, "", function (currency) {
        return "&currency=" + currency;
      }) + Belt_Option.mapWithDefault(language$1, "", function (language) {
        return "&language=" + language;
      });
    } else {
      return null;
    }
  };
  var match$2 = useSWRInfinite(getKey, function (key) {
    if (storeId !== undefined) {
      return FetchUtils$Showside.$$fetch(undefined, undefined, undefined, undefined, undefined, async function (json) {
        return IntermediateProductsResponse$Showside.$$Array.fromJson(hideOutOfStock, categoryId, storeId, json);
      }, key);
    } else {
      return Promise.resolve([]);
    }
  });
  var error = match$2.error;
  var data = match$2.data;
  var products = Belt_Option.map(data, Belt_Array.concatMany);
  var error$1 = products !== undefined && products.length === 0 ? {
    RE_EXN_ID: NotFound
  } : error;
  return {
    products: products,
    error: error$1,
    isFetching: data === undefined,
    numPages: match$2.size,
    setNumPages: match$2.setSize
  };
}
function splitIntoBatches(offsetOpt, len, input) {
  var offset = offsetOpt !== undefined ? offsetOpt : 0;
  return Belt_Array.concat([Belt_Array.slice(input, offset, len)], input.length > (offset + len | 0) ? splitIntoBatches(offset + len | 0, len, input) : []);
}
function useProductsById(storeId, ids, hideOutOfStock, shouldFetch, categoryId, smartnavApiHost, market, param) {
  var batches = splitIntoBatches(undefined, 20, ids);
  var getIds = function (page) {
    return Belt_Option.getWithDefault(Belt_Array.get(batches, page), []);
  };
  var match = useProductsByIdAndPage(storeId, getIds, hideOutOfStock, shouldFetch, categoryId, smartnavApiHost, market, undefined);
  var setNumPages = match.setNumPages;
  var numPages = match.numPages;
  var isFetching = match.isFetching;
  React.useEffect(function () {
    if (numPages < batches.length && !isFetching) {
      Curry._1(setNumPages, numPages + 1 | 0);
    }
  }, [numPages, isFetching]);
  return {
    products: match.products,
    error: match.error,
    isFetching: isFetching,
    numPages: numPages,
    setNumPages: setNumPages
  };
}
function useProductById(hideOutOfStock, categoryId, smartnavApiHost, market, productId) {
  Markets$Showside.getValues(market);
  var language = Belt_Option.map(Shopify$Showside.getLanguage(undefined), function (prim) {
    return prim.toUpperCase();
  });
  var match = ConfigurationProvider$Showside.use(undefined).config;
  var storeId = match.transitiveStoreId;
  var match$1 = SWRProductGroupByProductId$Showside.use(market, language, storeId, smartnavApiHost, hideOutOfStock, function (key) {
    if (storeId !== undefined) {
      return FetchUtils$Showside.$$fetch(undefined, undefined, undefined, undefined, undefined, async function (json) {
        return IntermediateProductsResponse$Showside.$$Array.fromJson(hideOutOfStock, categoryId, storeId, json);
      }, key);
    } else {
      return Promise.resolve([]);
    }
  }, productId);
  var error = match$1.error;
  var data = match$1.data;
  var product;
  try {
    product = Belt_Option.flatMap(data, function (data) {
      return Caml_option.undefined_to_opt(data.find(function (p) {
        return p.id === productId;
      }));
    });
  } catch (e) {
    product = undefined;
  }
  var isFetching = match$1.isValidating && data === undefined && error === undefined;
  return {
    product: product,
    error: error,
    isFetching: isFetching
  };
}
function useMarkets(smartnavApiHost, shouldFetch) {
  var match = ConfigurationProvider$Showside.use(undefined).config;
  var storeId = match.transitiveStoreId;
  var shouldFetch$1 = shouldFetch && storeId !== undefined;
  var markets = function (key) {
    return FetchUtils$Showside.$$fetch(undefined, undefined, undefined, undefined, undefined, async function (json) {
      return RescriptJsonUtils$Showside.decode(json, MarketsDecoders$ApiTypes.fromJson);
    }, key);
  };
  var getKey = function (param) {
    if (storeId !== undefined && shouldFetch$1) {
      return smartnavApiHost + "/api/get_markets?store_id=" + storeId;
    } else {
      return null;
    }
  };
  var match$1 = useSWR(getKey(undefined), markets);
  var data = match$1.data;
  var error = match$1.error;
  var isFetching = match$1.isValidating && data === undefined && error === undefined;
  return {
    markets: data,
    error: error,
    isFetching: isFetching
  };
}
function usePaginateCategories(useCacheOpt, smartnavApiHost, limit, firstPageUrl, param) {
  var useCache = useCacheOpt !== undefined ? useCacheOpt : false;
  var direction = React.useRef(1);
  var setDirection = function (nextDirection) {
    direction.current = nextDirection;
  };
  var fetcher = function (next) {
    return FetchUtils$Showside.$$fetch(undefined, undefined, undefined, undefined, undefined, async function (json) {
      return RescriptJsonUtils$Showside.decode(json, LegacyShowside_CategoryDecoders$ApiTypes.Page.fromJson);
    }, URLUtils$Showside.addHostnameMaybe(next, smartnavApiHost));
  };
  var getKey = function (index, lastPage) {
    var nextPage = Belt_Option.flatMap(lastPage == null ? undefined : Caml_option.some(lastPage), function (lastPage) {
      return lastPage.next;
    });
    var previousPage = Belt_Option.flatMap(lastPage == null ? undefined : Caml_option.some(lastPage), function (lastPage) {
      return lastPage.previous;
    });
    var match = direction.current;
    if (index !== 0) {
      if (match > 0) {
        return Js_null_undefined.fromOption(nextPage);
      } else if (match < 0) {
        return Js_null_undefined.fromOption(previousPage);
      } else {
        return null;
      }
    } else {
      return Js_null_undefined.fromOption(firstPageUrl);
    }
  };
  var paramDict = Js_dict.fromArray([["/api/get_config_nodes", "parent_id"], ["/api/get_related_media_by_products", "product_ids"], ["/api/get_related_media_by_category", "category_id"]]);
  var param$1 = React.useMemo(function () {
    return Belt_Option.flatMap(firstPageUrl, function (url) {
      return Belt_Option.flatMap(URLUtils$Showside.getPathname(URLUtils$Showside.addHostnameMaybe(url, smartnavApiHost)), function (path) {
        return Belt_Option.flatMap(Js_dict.get(paramDict, path), function (param) {
          return Belt_Option.map(URLUtils$Showside.getParam(URLUtils$Showside.addHostnameMaybe(url, smartnavApiHost), param), function (value) {
            return [path, param, value];
          });
        });
      });
    });
  }, [firstPageUrl]);
  var cachedPages = useCache ? Belt_SortArray.stableSortBy(Belt_Array.keep(Belt_Array.keepMap(Belt_Array.keep(Array.from(SWR.Cache.cache.keys()), function (key) {
    return Belt_Option.mapWithDefault(param$1, false, function (param) {
      if (key.includes(param[0])) {
        return key.includes(param[1] + "=" + param[2]);
      } else {
        return false;
      }
    });
  }), function (key) {
    return SWR.Cache.cache.get(key);
  }), function (page) {
    try {
      return page.categories.length !== 0;
    } catch (e) {
      return false;
    }
  }), function (pageA, pageB) {
    if (pageA.offset === pageB.offset) {
      return 0;
    } else if (pageA.offset > pageB.offset) {
      return 1;
    } else {
      return -1;
    }
  }) : [];
  var infiniteResult = useSWRInfinite(getKey, fetcher);
  return {
    swr: {
      data: useCache && cachedPages.length !== 0 ? cachedPages : infiniteResult.data,
      size: infiniteResult.size,
      setSize: infiniteResult.setSize,
      isValidating: infiniteResult.isValidating,
      error: infiniteResult.error,
      mutate: infiniteResult.mutate
    },
    setDirection: setDirection,
    direction: direction.current
  };
}
function useCategories(url) {
  var fetcher = function (url) {
    return FetchUtils$Showside.$$fetch(undefined, undefined, undefined, undefined, undefined, async function (json) {
      return RescriptJsonUtils$Showside.decode(json, LegacyShowside_CategoryDecoders$ApiTypes.Page.fromJson);
    }, url);
  };
  var getKey = function (param) {
    if (url !== undefined && url.trim() !== "") {
      return url;
    } else {
      return null;
    }
  };
  return useSWR(getKey(undefined), fetcher);
}
function useCacheOnlyProducts(smartnavApiHost, market, hideOutOfStock, productIds) {
  var match = Markets$Showside.getValues(market);
  var productsFromCache = SWRScrapeCache$Showside.getProductsById(smartnavApiHost, match.currency, match.country, productIds);
  return React.useMemo(function () {
    return productsFromCache;
  }, [productsFromCache.length]);
}
function categoriesPageFromJson(json) {
  return Curry._1(Store$ApiTypes.Categories.Page.fromJson, json);
}
function categoryFromJson(json) {
  return Store$ApiTypes.Category.fromJson(json);
}
function useCategoriesByProduct(smartnavApiHost, storeId, productId, param) {
  var fetcher = function (param) {
    return FetchUtils$Showside.$$fetch(undefined, undefined, undefined, undefined, undefined, async function (json) {
      return DeccoUtils$Showside.decode(json, categoriesPageFromJson);
    }, param);
  };
  var url = storeId !== undefined && productId !== undefined ? "" + smartnavApiHost + "/api/get_categories_by_product?product_id=" + productId + "&store_id=" + storeId + "" : null;
  return useSWR(url, fetcher);
}
function useCategory(smartnavApiHost, storeId, categoryId, param) {
  var partial_arg = FetchUtils$Showside.Server.ignoreNotFoundError;
  var fetcher = function (param) {
    return FetchUtils$Showside.$$fetch(undefined, undefined, undefined, undefined, partial_arg, async function (json) {
      return DeccoUtils$Showside.decode(json, categoryFromJson);
    }, param);
  };
  var url = storeId !== undefined && categoryId !== undefined ? "" + smartnavApiHost + "/api/get_category?category_id=" + categoryId + "&store_id=" + storeId + "" : null;
  return useSWR(url, fetcher);
}
export { NotFound, toInfiniteProductsResponse, isGood, fixSWRInfiniteResult, fixSWRResult, useSWRInfinite, useSWR, useCategoryProducts2, useCategoryProducts3, useCategoryProducts, useRelatedProducts, useProductsByIdAndPage, splitIntoBatches, useProductsById, useProductById, useMarkets, usePaginateCategories, useCategories, useCacheOnlyProducts, categoriesPageFromJson, categoryFromJson, useCategoriesByProduct, useCategory };
/* SWR Not a pure module */